import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type { Resource } from '@efdigital/ll-addon-data/types/content/resource';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import { findRecord } from '@warp-drive/utilities/json-api';

/**
 * Finds a resource by id
 * @param resourceId - The id of the resource to find
 * @returns JSON API request to find the resource
 */
export function findResource(resourceId: string) {
  return findRecord<Resource>(DataTypeContent.Resource, resourceId, {
    ...jsonApiOptions,
  } as FindRecordOptions);
}
